import { getDoc, doc, Firestore } from "firebase/firestore";

export type AdminDiagnostics = {
  isAdmin: boolean;
  roleValue: string | null;
  source: "users.role" | "admin.doc" | "none" | "error";
  error?: string;
};

export async function fetchIsAdminDetailed(db: Firestore, uid: string): Promise<AdminDiagnostics> {
  try {
    const userRef = doc(db, "users", uid);
    const userSnap = await getDoc(userRef);
    const role = userSnap.exists() ? (userSnap.data() as any)?.role ?? null : null;
    if (role === "admin") {
      return { isAdmin: true, roleValue: "admin", source: "users.role" };
    }
  } catch (e: any) {
    return { isAdmin: false, roleValue: null, source: "error", error: `users/{uid} read failed: ${e?.message ?? String(e)}` };
  }

  try {
    const adminRef = doc(db, "admin", uid);
    const adminSnap = await getDoc(adminRef);
    if (adminSnap.exists()) {
      return { isAdmin: true, roleValue: "admin", source: "admin.doc" };
    }
    return { isAdmin: false, roleValue: null, source: "none" };
  } catch (e: any) {
    return { isAdmin: false, roleValue: null, source: "error", error: `admin/{uid} read failed: ${e?.message ?? String(e)}` };
  }
}


